import { SVGFC } from '@repo/toolkit/types'

const FeesThreeIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8034 8.17383C15.7117 8.27195 17.2418 9.86309 17.2418 11.7943V16.4085C17.2418 18.4029 15.6102 20.0347 13.6158 20.0347H10.3858C8.3914 20.0347 6.75977 18.4029 6.75977 16.4085V11.7943C6.75977 9.86309 8.28987 8.27195 10.1984 8.17383"
        stroke={color}
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8306 16.6359H12.0979C12.7979 16.6359 13.3654 16.0685 13.3654 15.3686C13.3654 14.6687 12.7979 14.1012 12.0979 14.1012H11.9055C11.2055 14.1012 10.6382 13.5337 10.6382 12.8339C10.6382 12.134 11.2055 11.5666 11.9055 11.5666H13.1728M12.0979 17.5439V16.6358M12.0979 11.5666V10.6588M13.8042 8.32175C13.8042 8.68931 13.5062 8.98722 13.1386 8.98722H10.8647C10.4971 8.98722 10.1992 8.68931 10.1992 8.32175V8.01515C10.1992 7.64752 10.4971 7.34961 10.8647 7.34961H13.1386C13.5062 7.34961 13.8042 7.64752 13.8042 8.01515V8.32175Z"
        stroke={color}
        strokeWidth="0.7"
        strokeMiterlimit="10"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3001 7.6625C9.58243 7.15506 8.98512 6.56165 9.3395 6.15398C10.0788 5.3038 10.8924 6.15398 10.8924 6.15398C10.8924 6.15398 10.2158 3.95447 12.0981 4.95276C13.9799 3.9545 13.3033 6.15398 13.3033 6.15398C13.3033 6.15398 14.1168 5.3038 14.8562 6.15398C15.2339 6.58827 14.5312 7.23377 13.7536 7.76073"
        stroke={color}
        strokeWidth="0.7"
        fill="none"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FeesThreeIcon
